function checkMediaAltText() {
  const productTitle = document.querySelector(".product__title h1"); 
  const mediaTexts = document.querySelectorAll(".media-alt-text");

  if (productTitle) {
    const titleText = productTitle.innerText.trim();

    mediaTexts.forEach(el => {
      if (el.innerText.trim() === titleText) {
        el.classList.add("hide-cstm");
        el.classList.remove("show-cstm");
      } else {
        el.classList.add("show-cstm");
        el.classList.remove("hide-cstm");
      }
    });
  }
}

// run every second
setInterval(checkMediaAltText, 1000);

// also run immediately on load
document.addEventListener("DOMContentLoaded", checkMediaAltText);